





import { Vue, Component } from 'vue-property-decorator';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
@Component
export default class App extends Vue {
  public page = Number(localStorage.getItem('page'));
}
